import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

export const BlotterTitleContainer: FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <div className={classNames('d-flex px-3 flex-grow-1 align-items-center gap-1', className)}>{children}</div>
);

export const BlotterTitleLabel: FC<PropsWithChildren<{}>> = ({ children }) => (
  <h5 className="text-md-nowrap">{children}</h5>
);
